import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { PermissionsModule } from '../../auth/permissions/permissions.module';
import { ArrayIncludesPipe } from '../../shared/helpers/pipes/common/common-pipes.pipe';
import { IsPageActivePipe, SidenavComponent } from './sidenav.component';

@NgModule({
  declarations: [SidenavComponent, IsPageActivePipe],
  imports: [
    CommonModule,
    RouterModule,
    MatExpansionModule,
    MatIconModule,
    MatDividerModule,
    PermissionsModule,
    TranslocoModule,
    ArrayIncludesPipe,
  ],
  exports: [SidenavComponent],
})
export class SidenavModule {}
